/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q7Inputs */

const en_pc_faq_q7 = /** @type {(inputs: Pc_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which systems does PdfCraft support?`)
};

const zh_pc_faq_q7 = /** @type {(inputs: Pc_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 支持哪些系统？`)
};

/**
* | output |
* | --- |
* | "Which systems does PdfCraft support?" |
*
* @param {Pc_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q7 = /** @type {((inputs?: Pc_Faq_Q7Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q7Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q7(inputs)
	return zh_pc_faq_q7(inputs)
});
export { pc_faq_q7 as "pc.faq.q7" }